export { getStoresServerAction } from 'next-flight-server-reference-proxy-loader?id=7094be621bfbb97dfab58f5bce69dce23f6ec400a3&name=getStoresServerAction!'